import * as TechInfosActions from './tech-info.actions';

export {TechInfosActions};
